import {
  StreamlineCheckoutData,
  StreamlineCheckoutVariant,
  StreamlineCheckoutTestResult,
  UseStreamlineCheckout,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";
import { useSearchParams } from "next/navigation";

const CUSTOM_RULE_ID = "streamlineCheckout";

/**
 * This experiment can return one of two variants:
 * - control: Original design
 * - test: New design with branding color and images
 */
const useStreamlineCheckout: UseStreamlineCheckout = () => {
  const { isLoading, value } = useMonarchRule<{
    data: StreamlineCheckoutData;
  }>(CUSTOM_RULE_ID, {});

  const searchParams = useSearchParams();
  const isEdAssist = searchParams.get("edassist") === "true";

  if (isLoading || !value) {
    return {
      isLoading,
    } as StreamlineCheckoutTestResult;
  }

  const variant: StreamlineCheckoutVariant = value.data.showRedesign
    ? "test"
    : "control";

  // Override coupon values with edAssist values when edassist=true query param is present
  const couponCode =
    isEdAssist && value?.data?.edAssistCouponCode
      ? value.data.edAssistCouponCode
      : value?.data?.couponCode;

  const discountPercentage =
    isEdAssist && value?.data?.edAssistDiscountPercentage
      ? value.data.edAssistDiscountPercentage
      : value?.data?.discountPercentage;

  return {
    isLoading: false,
    variant,
    data: {
      showRedesign: value?.data?.showRedesign,
      position: value?.data?.position,
      showPill: value?.data?.showPill,
      showPrice: value?.data?.showPrice,
      showStrikethroughPrice: value?.data?.showStrikethroughPrice,
      headlineText: value?.data?.headlineText,
      discountPercentage,
      buttonText: value?.data?.buttonText,
      finePrint: value?.data?.finePrint,
      couponCode,
      iconText: value?.data?.iconText,
    },
  };
};

export default useStreamlineCheckout;
